export const KEYWORD_MARKET_ANALYSIS_GROUP_SEARCH_TRENDS_STATE =
    "digitalsuite_marketresearch_keywordmarketanalysis_demand_search_trends";
